// extracted by mini-css-extract-plugin
export default {"diffIcon":"styles_diffIcon__VXUas","diff":"styles_diff__s5ine","up":"styles_up__pR50o","down":"styles_down__FlOZQ"};